import React from 'react';
import { MessageCircle } from 'lucide-react';
import { WA_FLOAT } from '@/constants/testIds';

export const WhatsAppFloat = () => {
    const msg = encodeURIComponent("Hi Mindstorm, I'd like to discuss an upcoming event.");
    const href = `https://wa.me/919986345269?text=${msg}`;
    return (
        <a
            data-testid={WA_FLOAT}
            href={href}
            target="_blank"
            rel="noreferrer"
            aria-label="Chat on WhatsApp"
            className="fixed bottom-24 right-5 z-40 group"
        >
            <div className="absolute inset-0 rounded-full bg-gold/40 animate-ping" />
            <div className="relative w-14 h-14 rounded-full bg-gold flex items-center justify-center shadow-2xl border-2 border-black transition-transform group-hover:scale-110">
                <MessageCircle size={22} className="text-black" strokeWidth={2} />
            </div>
        </a>
    );
};

export default WhatsAppFloat;
